<template>
	<div class='content'>
		<Modal v-model="showModal" title="题目配置" :footer-hide="true"
			:loading="$root.$children[0].modalLoading" width="1243" class="edit-test-modal top my-modal">
			<div class="test-wrap">
				<div class="title">
					<div>题目配置</div>
					<div>操作</div>
				</div>
				<div v-for="(item, index) in testList" :key="index">
					<div class="content title-box">
						<div class="title-wrap">题目{{ index + 1 }}</div>
						<div class="input-wrap"> <Input v-model="item.title" placeholder="请输入..." /></div>
						<div class="type-wrap">
							<RadioGroup v-model="item.isChooseMore" size='default' :disabled="!canEdit">
								<Radio label="0">单项选题</Radio>
								<Radio label="1">多项选题</Radio>
							</RadioGroup>
						</div>
						<div class="action-wrap">
							<span @click="addTest(index)">新增题目</span>
							<span @click="addOptions(index)">新增选项</span>
							<span @click="showRemarkPopup(item)">考题解析</span>
							<span v-if="testList.length > 1"
								@click="testList.length > 1 && delTest(index)">删除题目</span>
						</div>
					</div>
					<div v-for="(sub, idx) in item.options" :key="idx" class="content">
						<div class="title-wrap">选项{{ letters[idx] }}</div>
						<div class="input-wrap"> <Input v-model="sub.content" placeholder="请输入..." /></div>
						<div class="type-wrap">
							<RadioGroup v-model="sub.isTrue" size='default' :disabled="!canEdit">
								<Radio label="1">正确答案</Radio>
								<Radio label="0">错误答案</Radio>
							</RadioGroup>
						</div>
						<div class="action-wrap">
							<!-- <span v-if="item.options.length > 1" @click="addOptions(index, idx)">新增选项</span> -->
							<span v-if="item.options.length > 1" @click="delOptions(index, idx)">删除选项</span>
						</div>
					</div>
				</div>

				<div class="ivu-modal-footer" slot="footer">
					<Button type="text"  @click="showModal=false">取消</Button>
					<Button type="primary" @click="confirm" >确定</Button>
				</div>
			</div>
		</Modal>
		<Modal v-model="showRemark" title="考题解析" @on-ok="canEdit && save" @on-cancel="canEdit && reset" width="800">
			<div class="remark-wrap">
				<Input v-model="sel.content" type="textarea" placeholder="输入考题解析内容" />
			</div>
		</Modal>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				canEdit: true,
				sel: {},
				selRemark: '',
				letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
				testList: [{
					title: '', //选项标题
					courseId: '', //课程id
					isChooseMore: '0', //0-单选1-多选
					orderNum: 0,
					remark: '',
					type: 1, // 题目类型 1-课后作业 2-考试试题  3-问卷课程中心 默认写死 =1
					options: [{
						title: 'A',
						orderNum: 0,
						content: '',
						isTrue: '0', //0 错误  1正确
					}]
				}], //题目列表
				showModal: false,
				isUpload: false,
				showRemark: false,
				courseId: '', //课程
			}
		},
		created() {},
		methods: {
			save() {
				this.showRemark = false;
			},
			reset() {
				this.sel.content = this.selRemark;
			},
			showRemarkPopup(item) {
				this.sel = item;
				this.selRemark = item.content;
				this.showRemark = true;
			},
			delTest(index) {
				this.testList.splice(index, 1)
			},
			delOptions(index, idx) {
				this.testList[index].options.splice(idx, 1)
			},
			addOptions(index, idx) {
				let data = {
					title: 'A',
					orderNum: 0,
					content: '',
					isTrue: '0', //0 错误  1正确
				}
				if (idx != undefined) {
					this.testList[index].options.splice(idx + 1, 0, data)
				} else {
					this.testList[index].options.push(data)
				}

			},
			addTest(index) {
				let data = {
					title: '', //选项标题
					courseId: this.courseId, //课程id
					isChooseMore: '0', //0-单选1-多选
					orderNum: 0,
					remark: '',
					type: 1, // 题目类型 1-课后作业 2-考试试题  3-问卷课程中心 默认写死 =1
					options: [{
						title: 'A',
						orderNum: 0,
						content: '',
						isTrue: '0', //0 错误  1正确
					}]
				}
				this.testList.splice(index + 1, 0, data)
			},
			open(item) {
				this.canEdit = item.useTime ? false : true;
				if (item.id) {
					this.courseId = item.id;
					this.getDetail();
				}
				this.showModal = true;
			},
			// 详情
			getDetail() {
				this.$http({
					url: `/buz/courseQuestion/read/detail`,
					type: "GET",
					data: {
						id: this.courseId
					}
				}).then(res => {
					if (res.data && res.data.length) {
						this.testList = res.data.map(item => {
							if (item.options) {
								item.options = JSON.parse(item.options)
							}
							return item;
						})
					} else {
						this.testList = [{
							title: '', //选项标题
							courseId: '', //课程id
							isChooseMore: '0', //0-单选1-多选
							orderNum: 0,
							remark: '',
							type: 1, // 题目类型 1-课后作业 2-考试试题  3-问卷课程中心 默认写死 =1
							options: [{
								title: 'A',
								orderNum: 0,
								content: '',
								isTrue: '0', //0 错误  1正确
							}]
						}]
					}
				})
			},
			confirm() {
				// if (!this.canEdit) {
				// 	this.showModal = false;
				// 	return
				// }
				let isEmpty = false;
				let errMsg = '';
				this.$units.notCloseModal(this);
				let allEmpty = true;
				if (this.testList.length == 1) {
					this.testList.forEach(item => {
						if (item.title) allEmpty = false;
						if (item.options) {
							item.options.forEach((sub, idx) => {
								if (sub.content) allEmpty = false;
							})
						}
					})
				} else {
					allEmpty = false;
				}
				let emptyItem = [];
				if (!allEmpty) {
					this.testList.forEach((item, index) => {
						item.orderNum = index;
						if (!item.title && item.options.every(i => !i.content)) { //当前题目 没有填写题目和任何选项
							emptyItem.push(index);
						} else if (!item.title) { //当前题目 没有填写题目
							isEmpty = true;
						} else {
							let len = item.options.filter(i => i.isTrue == 1).length;
							if (item.isChooseMore == 0) { //单选
								if (len > 1) {
									errMsg = `题目${index + 1}为单项选题，只能有一个正确答案`;
								} else if (len == 0) {
									errMsg = `题目${index + 1}为单项选题，需要设置正确答案`;
								}
							} else if (item.isChooseMore == 1) { //多选
								if (len < 2) {
									errMsg = `题目${index + 1}为多项选题，最少有两个正确答案`;
								}
							}
							if (item.options) {
								item.options.forEach((sub, idx) => {
									sub.orderNum = idx;
									sub.title = this.letters[idx];
									if (!sub.content) isEmpty = true;
								})
							}
						}
					})
					if (errMsg) {
						return this.$notice.error(errMsg);
					}
					if (isEmpty) {
						return this.$notice.error("您还有题目没有填写");
					}
				}
				if (allEmpty) {
					this.$notice.inquiry('当前未配置考试题目，是否退出？').then(() => {
						this.saveTest({
							params: [],
							courseId: this.courseId,

						})
					})
				}else if(emptyItem.length){
					//过滤掉为配置题目
					this.$notice.inquiry('您当前还有题目未配置，是否保存？').then(() => {
						let arr = this.testList.filter((t,i) => {
							return emptyItem.indexOf(i) == -1;
						});
						this.saveTest({
							params: arr,
							courseId: this.courseId,
					
						})
					})
				} else {
					this.saveTest({
						params: this.testList,
						courseId: this.courseId
					})
				}
			},

			saveTest(data) {
				this.$http({
					url: `/buz/courseQuestion/edit`,
					type: "POST",
					data,
          apiPermissionCode:'operate_3_1_2'
				}).then(res => {
					this.$Message.success('操作成功')
					this.showModal = false
					this.$emit('reload');
				})
			}
		},
	}
</script>
<style lang='scss' scoped>
	.disabled {
		cursor: unset !important;
		color: #727C8E !important;
	}

	.ivu-modal-confirm-footer {
		display: flex;
		justify-content: center;

		.ivu-btn {
			flex: 0 0 78px;
		}
	}

	/deep/.ivu-modal-body {
		padding: 27px 40px 0 30px;
	}

	* {
		box-sizing: border-box;
	}

	.test-wrap {
		border: 1px solid #E9E9E9;
		max-height: 500px;
		overflow: scroll;
		margin-top: 10px;

		.title {
			display: flex;
			border-bottom: 1px solid #E9E9E9;

			>div {
				width: 613px;
				height: 38px;
				background: #F7F7F7;
				border-right: 1px solid #E9E9E9;
				line-height: 38px;
				text-align: center;
				font-size: 14px;
				color: #515C6F;

			}

			& :last-child {
				border-right: none;
				width: 560px;
			}
		}

		.title-box {
			border-top: 10px solid #fff;
		}

		.content {
			display: flex;
			border-bottom: 1px solid #E9E9E9;

			/* &:last-child {
				border-bottom: none;
			}
 */
			.title-wrap {
				width: 70px;
				height: 54px;
				text-align: center;
				background: #F7F7F7;
				line-height: 54px;
				border-right: 1px solid #E9E9E9;
			}

			.input-wrap {
				padding: 0 10px;
				width: 536px;
				text-align: center;
				height: 54px;
				background: #F7F7F7;
				line-height: 54px;
				border-right: 1px solid #E9E9E9;
			}

			.type-wrap {
				width: 220px;
				height: 54px;
				line-height: 54px;
				border-right: 1px solid #E9E9E9;
				padding-left: 45px;
			}

			.action-wrap {
				text-align: center;
				flex: 1;

				span {
					line-height: 54px;
					cursor: pointer;
					width: 56px;
					font-size: 14px;
					color: #236DFF;
					margin-left: 20px;
				}

				& :first-child {
					margin-left: 0;
				}

			}
		}

	}
</style>
